define('modules/audiences/segments/export/main',["T1Module"], function (T1Module) {
  "use strict";

  var instance;
  if (instance === undefined) {
    instance = new T1Module({
      name: "audiences/segments/export",
      viewCfgs: {
        segments: {}
      },
      defaultView: "export"
    });
  }
  return instance;
});
